import { Injectable } from '@angular/core';
import { Http, URLSearchParams, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { BaseService } from './base-service';
import { UserService } from './user-service';

import { API_TIMEOUT } from './config';

@Injectable()
export class PodcastService extends BaseService {

  constructor(public http: Http, public userService: UserService) {
    super();
    console.log('Hello PodcastService Provider');
  }

  info(podcastId) {
    const url = `${super.url()}/podcasts/${podcastId}`;
    const headers = { headers: this.userService.getAuthorizationHeaders() };
    return this.http.get(url, headers)
      .timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

  episodes(podcastId, skip = null) {
    let params = new URLSearchParams();
    // limit
    params.set('limit', '10');
    // skip elements for infinite scrolling
    if (skip) {
      params.set('skip', String(skip));
    }
    // fetching podcast info to get title
    return this.info(podcastId)
      .flatMap((podcast: any) => {
        const url = `${super.url()}/podcasts/${podcastId}/episodes`;
        const headers = { headers: this.userService.getAuthorizationHeaders(), search: params };
        // fetching episodes
        return this.http.get(url, headers)
          .timeout(API_TIMEOUT)
          .flatMap((res: Response) => {
            const data = res.json();
            // remapping episodes to proper format
            const remappedData: any[] = this.remapProperties(data.data, podcast.title);
            return Observable.of(remappedData);
          })
          .catch(this.handleError);
      })
      .catch(this.handleError);
  }

  lastEpisode(podcastId) {
    // fetching podcast info to get title
    return this.info(podcastId)
      .flatMap((podcast: any) => {
        let params = new URLSearchParams();
        params.set('limit', '1'); // todo: limit
        const url = `${super.url()}/podcasts/${podcastId}/episodes`;
        const headers = { headers: this.userService.getAuthorizationHeaders(), search: params };
        // fetching episodes
        return this.http.get(url, headers)
          .timeout(API_TIMEOUT)
          .flatMap((res: Response) => {
            const data = res.json();
            // remapping episodes to proper format
            const remappedData: any[] = this.remapProperties(data.data, podcast.title);
            return Observable.of((remappedData.length > 0) ? remappedData[0] : null);
        })
        .catch(this.handleError);
    })
    .catch(this.handleError);
  }

  search(keywords: string) {
    let params = new URLSearchParams();
    params.set('keywords', keywords);
    params.set('limit', '50');
    const url = `${super.url()}/podcasts/search`;
    const headers = { headers: this.userService.getAuthorizationHeaders(), search: params };
    // fetching podcasts
    return this.http.get(url, headers)
      .timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

  searchEpisodes(podcastId: string, keywords: string) {
    // fetching podcast info to get title
    return this.info(podcastId).subscribe((podcast: any) => {
      let params = new URLSearchParams();
      params.set('keywords', keywords);
      const url = `${super.url()}/podcasts/${podcastId}/episodes/search`
      const headers = { headers: this.userService.getAuthorizationHeaders(), search: params };
      // fetching episodes
      return this.http.get(url, headers).timeout(API_TIMEOUT).map(res => {
        const data = res.json();
        // remapping episodes to proper format
        const remappedData: any[] = this.remapProperties(data.data, podcast.title);
        return remappedData;
      })
      .catch(this.handleError);
    });
  }

  remapProperties(episodes: any[], artist?: string) {
    var remappedEpisodes: any[] = [];
    episodes.forEach((e) => {
      remappedEpisodes.push(this.remapEpisodeProperties(e));
    });
    return remappedEpisodes;
  }

  remapEpisodeProperties(e: any, artist?: string) {
    return {
      _id: e._id,
      _playback: (e._playback) ? e._playback : null,
      title: e.title,
      artist: artist,
      description: e.description,
      audioLength: e.length,
      date: e.publishedAt,
      src: e.linkUrl,
      image: e.imageUrl,
      preload: 'metadata'
    };
  }

}



// WEBPACK FOOTER //
// ./src/providers/podcast-service.ts